import styled from "styled-components";

export const VendorDashboardContainer = styled.div`
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  color: black;
  font-family: var(--thdFontFamily);
`;

export const VendorDashboardContent = styled.div`
  position: fixed;
  top: 10%;
  left: 15%;
  width: 85%;
  height: 90%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  @media (max-width: 768px) {
    visibility: ${(props) => (props.showNavBar ? "hidden" : "visible")};
    width: 100vw;
    height: 100vh;
    top: 10%;
    left: 0%;
    position: absolute;
  }
`;
